var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 224,
    viewBox: "0 0 228 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 112C227.5 173.571 176.693 223.5 114 223.5C51.3073 223.5 0.5 173.571 0.5 112C0.5 50.4286 51.3073 0.5 114 0.5C176.693 0.5 227.5 50.4286 227.5 112Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircled);
export default __webpack_public_path__ + "static/media/circled.c7d8fb35a040ca4112e98cc5fc117b52.svg";
export { ForwardRef as ReactComponent };